<div class="relative ml-3 align-middle" (clickOutside)="closeProfileMenu()">
  <div>
    <button (click)="toggleProfileMenu()" type="button" id="user-menu-button"
            class="relative flex items-center rounded-full">
      @if (currentUser) {
        <avatar-icon [user]="currentUser"/>
      }
      @if (isPendingUsersIndicatorVisible()) {
        <div id="pending-users-indicator"
             class="relative flex h-3 w-3 -top-3 end-1">
          <span
            class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-500 opacity-75"></span>
          <span class="relative inline-flex rounded-full h-3 w-3 bg-blue-500"></span>
        </div>
      }
    </button>
  </div>

  @if (isProfileClicked) {
    <div id="profile-dropdown-menu"
         class="absolute right-0 z-10 mt-2 w-[300px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
         role="menu">
      <div class="border-b border-gray-300 pb-1 pt-2 w-full">
        <div class="flex align-middle items-center">
          <div id="profile-user-name"
               class="px-4 py-2 text-sm font-bold">
            {{ currentUser?.first_name }} {{ currentUser?.last_name }}
          </div>
          <div class="pr-2">
            <span id="profile-user-role"
                  class="px-1 py-0.5 bg-blue-100 text-blue-800 text-xs font-bold rounded whitespace-nowrap">
              {{ currentUser?.role }}
            </span>
          </div>
        </div>
        <div class="flex w-full ">
          <span id="profile-user-email"
                class="px-4 py-1 text-sm text-gray-700 font-thin break-all">{{ currentUser?.email }}</span>
        </div>
        <div class="flex align-bottom px-4 py-2 text-sm text-gray-700 font-thin">
          <div class="pr-1">
            <svg class="w-5 h-5 text-gray-700 " aria-hidden="true"
                 xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 4h12M6 4v16M6 4H5m13 0v16m0-16h1m-1 16H6m12 0h1M6 20H5M9 7h1v1H9V7Zm5 0h1v1h-1V7Zm-5 4h1v1H9v-1Zm5 0h1v1h-1v-1Zm-3 4h2a1 1 0 0 1 1 1v4h-4v-4a1 1 0 0 1 1-1Z"/>
            </svg>
          </div>
          <div id="profile-user-company">
            {{ currentUser?.companies }}
          </div>
        </div>
      </div>
      @if (hasPermission(Permission.ViewPendingUsers)) {
        <div class="hover:bg-gray-100">
          <a (click)="routeToPendingUsers()" id="pending-users-link"
             class="block px-4 py-2 text-sm text-gray-700 cursor-pointer hover:text-blue-700">
            <div class="flex items-center" [class.navbar-active-item]="isCurrentPageHref('pending-users')">
              Pending Users
              <div id="pending-users-count"
                   class="ml-2 flex items-center justify-center text-2xs text-white bg-blue-500 rounded-full w-4 h-4 overflow-hidden font-bold">
                {{ totalPendingItems }}
              </div>
            </div>
          </a>
        </div>
        <div class="hover:bg-gray-100">
          <a (click)="routeToInvitedUsers()" id="invited-users-link"
             class="block px-4 py-2 text-sm text-gray-700 cursor-pointer hover:text-blue-700">
            <div class="flex items-center" [class.navbar-active-item]="isCurrentPageHref('invited-users')">
              Invited Users
            </div>
          </a>
        </div>
      }
      <div class="border-t border-gray-300 pt-1 hover:bg-gray-100 pb-1">
        <a (click)="logout()" id="profile-logout-link"
           class="block px-4 py-2 text-sm text-red-700 cursor-pointer hover:text-red-500">
          Sign out
        </a>
      </div>
    </div>
  }
</div>
